"use client";

import ReactDOM from "react-dom";
import ModalRoot from "./ModalRoot";

const ModalPortal = () => {
    if (typeof window === "undefined") return null;

    return ReactDOM.createPortal(<ModalRoot />, document.body);
}

export default ModalPortal;
